/*
 * patient-fax (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { patientFaxes, FAX_STATUSES } from "./patient-fax.schema"

export { FAX_STATUSES }
export type { FaxStatus } from "./patient-fax.schema"

/* Select */
export type PatientFax = z.infer<typeof selectPatientFaxSchema>
export const selectPatientFaxSchema = createSelectSchema(patientFaxes)

/* Filters */
export type PatientFaxFilters = z.infer<typeof patientFaxFiltersSchema>
export const patientFaxFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	status: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPatientFaxSchema = createInsertSchema(patientFaxes, {
	patientId: z.string().uuid(),
	recipientFaxNumber: z.string().min(1, "Fax number is required"),
}).partial(globalCreateExclude)
export type CreatePatientFax = z.infer<typeof createPatientFaxSchema>

/* Update */
export const updatePatientFaxSchema = createInsertSchema(patientFaxes)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePatientFax = z.infer<typeof updatePatientFaxSchema>

/* Send input */
export const sendFaxInputSchema = z.object({
	patientId: z.string().uuid(),
	fileAttachmentIds: z.string().uuid().array().min(1),
	recipientName: z.string().optional(),
	recipientFaxNumber: z.string().min(1),
	subject: z.string().optional(),
})
export type SendFaxInput = z.infer<typeof sendFaxInputSchema>

export { FAX_STATUSES as FAX_STATUS_VALUES }
